import React from 'react';
import { toast, ToastContainer, MDBIframe, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBContainer, MDBInput } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from '../Components/ComponentFragments/Header';



export default class TermsAndConditions extends React.Component {

    constructor(props) {
        super(props);
        //this.props.loaderOff();
        this.state = {
            acceptedTerms: "false",
            disabled: true
        }
        this.changeHandler = this.changeHandler.bind(this);
        this.acceptTerms = this.acceptTerms.bind(this);
    }

    async acceptTerms() {

        var dl = new DataLayer();
        let response = await dl.Get('/demonstrator/acceptTerms');
        if (response.errorOccurred) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Error Occurred.</span>, {
                closeButton: false
            });
        } else {
            //var TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
            //TMAUser.data.acceptedTerms = true;
            //localStorage.getItem("TMAUser").data.acceptedTerms = true;
            //window.location.reload();
            const { history } = this.props;
            history.push('/salesforce');
            //this.props.setSideBarItems(TMAUser, this.props.shopCategories);
        }
    }

    changeHandler(value) {
        if (value == "false") {
            let test = value;
            this.setState({
                acceptedTerms: "true",
                disabled: false
            })
        } else {
            let sjdsk = value;
            this.setState({
                acceptedTerms: "false",
                disabled: true
            })
        }

        //alert(this.state.acceptedTerms);
    };

    render() {

        return (
            <div>
                <div style={{ textAlign: "center", paddingTop:"10px" }}>
                    <h4><strong>New Demonstrator</strong></h4>
                    <h5><strong>Terms And Conditions</strong></h5>
                    </div>
                <MDBContainer className="text-center">
                    <MDBIframe height={500} src="https://amp.tuppafrica.co.za/DemTermsAndConditions.html" />
                </MDBContainer>
                <MDBRow>
                    <div style={{paddingLeft:"15px"}}>
                        <MDBInput getValue={this.changeHandler} value={this.state.acceptedTerms} label="I accept the Terms and Conditions" type="checkbox" name="acceptedTerms" id="acceptedTerms" />
                    </div>
                </MDBRow>
                <MDBRow>
                    <div style={{ paddingLeft: "15px" }}>
                        <MDBBtn rounded disabled={this.state.disabled} color="purple" size="sm" onClick={this.acceptTerms}><MDBIcon far icon="thumbs-up" />&nbsp;Proceed</MDBBtn>
                        </div>
                </MDBRow>
            </div>
        );
    }
}